import { hexToRgba } from "utils/Utils";
import { getAdjustedFontSize } from "./StylesHelper";
import React from "react";

const CategoryTabs = ({
  lists,
  styles,
  activeCategoryId,
  setActiveCategoryId,
}) => {
  return (
    <div className="preview_categories">
      <div className="categories_btns d-flex gap-2">
        {lists.map((cat) => {
          const isActive = cat.categoryId === activeCategoryId;

          return (
            <button
              key={cat.categoryId}
              type="button"
              className={isActive ? "active" : ""}
              onClick={() => setActiveCategoryId(cat.categoryId)}
              style={{
                backgroundColor: isActive
                  ? hexToRgba(styles.primaryColor, styles.primaryColorOpacity)
                  : hexToRgba(
                      styles.secondaryColor,
                      styles?.secondaryColorOpacity
                    ),
                color: isActive
                  ? styles.primaryTextColor
                  : styles.secondaryTextColor,
                border: `1px solid ${
                  isActive
                    ? styles.primaryBorderColor
                    : styles.secondaryBorderColor
                }`,
                borderRadius: styles.borderRadius || 0,
                fontSize: getAdjustedFontSize(
                  styles.size === "normal" ? 16 : 14,
                  styles.family
                ),
                fontFamily: styles.family || "inherit",
                padding: "8px 16px",
              }}
            >
              {cat.categoryName}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryTabs;
